import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 12L21 12M21 12L12.5 3.5M21 12L12.5 20.5",
		stroke: "#292929",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrow;
